import React, { useState, useContext } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import { IconButton } from '@mui/material';
import logo from "./logo.png"

const paymentMethods = [
	// {
	// 	type: 'PayPal',
	// 	desc: `make payment with Paypal`,
	// 	logo: '../assets/PayPal.png',
	// },
	{
		type: 'Mastercard',
		desc: ``, // make payment with mastercard
		logo: '../assets/logo.png', // ../assets/mastercard.png
	},
	// {
	// 	type: 'Apple Pay',
	// 	desc: `make payment with Apple Pay`,
	// 	logo: '../assets/Pay.png',
	// },
];

const PaymentMethodBtn = ({ onClick, desc, logo, type, selected }) => {
	const { language, handleLanguageChange } = useContext(LanguageContext);

	const clickHandler = (e) => {
		e.stopPropagation();
		onClick(type);
	};
	return (
		<button
			onClick={clickHandler}
			type="button"
			className={`w-full bg-tet-700 drop-shadow-msg border-[1.5px] py-4 border-sec-80 sm:pl-5 pl-2 sm:pr-11 pr-2 rounded-2xl flex items-center gap-4 transition-all duration-75 ${
				type === selected ? 'border-pry-800' : 'bg-tet-700'
			}`}>
			<span
				className={`pointer-events-none w-4 h-4 border-[1.5px] border-pry-100 block rounded-[50%] ${
					type === selected ? 'bg-pry-800' : 'bg-tet-700'
				} border border-tet-100 flex-checker`}></span>
			<p className="pointer-events-none sm:text-base text-sm text-black">
				{language["m_btn"]}
			</p>
			{/* <img
				width={48}
				height={48}
				className="pointer-events-none ml-0"
				src={logo}
				alt={type}
			/> */}
		</button>
	);
};

//import language context
import { LanguageContext } from '../scenes/global/languageContext';


const PaymentMethodModal = ({ hideModal }) => {
	const { language, handleLanguageChange } = useContext(LanguageContext);

	const navigate = useNavigate();
	const [payMethod, setPayMethod] = useState('');
	const payBtnClickHandle = (value) => {
		setPayMethod(value);
	};
	console.log('payMethod', payMethod);
	if (payMethod === 'Mastercard') {
		navigate('/allCv');
	}
	return (
		<div className="fixed top-0 left-0 bottom-0 right-0 z-10 backdrop-blur-[2px] bg-tet-600 flex justify-center items-center">
			<section className="bg-white sm:max-w-[706px] min-w-[350px] w-[80%] mt-10 mx-auto rounded-3xl sm:px-10 p-3">
				<header className="flex justify-start items-center">
					<h3 className="text-lg sm:text-2xl font-medium text-tet-500">
						{language["m_top_text"]}
					</h3>
					<figure>
						<img
							width={48}
							height={48}
							src={logo} // coin.png
							className="pointer-events-none ml-2"
							alt="coin"
						/>
					</figure>
					<IconButton
						size="medium"
						aria-label="delete"
						sx={{
							marginLeft: 'auto',
						}}
						onClick={hideModal}>
						<CloseIcon />
					</IconButton>
				</header>
				<div
					className="max-w[
559px] flex flex-col gap-6 justify-center mt-5 pb-5 sm:mt-10">
					{paymentMethods.map((paymentMethod) => {
						return (
							<PaymentMethodBtn
								key={paymentMethod.type}
								{...paymentMethod}
								onClick={payBtnClickHandle}
								selected={payMethod}
							/>
						);
					})}
				</div>
			</section>
		</div>
	);
};

export default PaymentMethodModal;
